module.exports = __webpack_public_path__ + "img/icon_submenu9dark.463cd303.svg";